import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataTable, DataTableResource } from 'angular-4-data-table-bootstrap-4';

import { ApiService, ModelService } from '../../../services';

@Component({
    selector: 'sn-attachment-list',
    templateUrl: './attachment-list.component.html',
    styleUrls: ['./attachment-list.component.css']
})
export class AttachmentListComponent implements OnInit {
    public mode_viewer: string = "viewer";
    public mode_picker: string = "picker";

    @Input() public columns: any;
    @Input() public related_type: any;
    @Input() public related_ID: any;
    @Input() public mode: string = this.mode_viewer;
    @Output() selectEvent = new EventEmitter();
    @Output() downloadEvent = new EventEmitter();

    public attachments: Array<any> = [];
    public allAttachments: Array<any> = [];

    searchText:string = "";
    items: any[] = [];
    itemCount:number = 0;
    itemResource = new DataTableResource(this.attachments);
    lastParams:any;

    filterParams = ["filename", "type", "sub_type", "filesize"];

    isPicker() { return this.mode == this.mode_picker; }
    isViewer() { return this.mode == this.mode_viewer; }

    isVisible(col:any) {
        let tokens: Array<any> = this.columns.split(' ');
        return tokens.indexOf(col) >= 0;
    }

    reloadItems(params:any) {
        //console.log(params);
        this.lastParams = params;
        this.itemResource.query(params).then(
            items => {
                this.items = items;
                // console.log(items);
            }
        );
        this.itemResource.count().then(count => this.itemCount = count);
    }

    constructor(
        private modelService: ModelService,
        private apiService: ApiService,
    ) { }

    ngOnInit() {
        this.modelService.loadRelatedFiles(this.related_type, this.related_ID).subscribe(
            result => {
                this.allAttachments = result;
                this.attachments = this.allAttachments;
                this.itemResource = new DataTableResource(this.attachments);
                this.itemResource.count().then(count => this.itemCount = count);
            }
        )
        console.log("AttachmentListComponent", this.mode);
    }

    onChange($event:any) {
        var filteredItems:any[] = [];
        this.allAttachments.forEach(
            u => {
                for (var i = 0; i < this.filterParams.length; i++) {
                    var p = this.filterParams[i];
                    if (this.isVisible(p) && u[p].toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0) {
                        filteredItems.push(u);
                        break;
                    }
                }
            }
        );
        this.attachments = filteredItems;
        this.itemResource = new DataTableResource(this.attachments);
        this.lastParams.offset = 0; // reset the index/paging info
        this.reloadItems(this.lastParams);
    }

    getDate(item:any) {
        return "na";
    }

    onSelect(item:any) {
        if (this.selectEvent) {
            this.selectEvent.emit({ selectedItem: item });
        }
    }

    onDownload(item:any) {
        if (this.downloadEvent) {
            this.downloadEvent.emit({ selectedItem: item });
        }
    }

    getFilesize(filesize:any) {
        filesize = parseInt(filesize);
        var kb = filesize / 1024;
        var mb = kb / 1024;
        if (mb > 1) return `${mb.toFixed(2)} MB`;
        else if (kb > 1) return `${kb.toFixed(2)} KB`;
        return `${filesize} Bytes`;
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/list/attachment-list/attachment-list.component.ts